import React, { useEffect, useState } from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import PageHeader from 'components/common/PageHeader';
import { useQuery } from "@tanstack/react-query";
import { getAthletes } from "../data/Querys";
import NotAvailable from "../components/common/NotAvailable";
import Loader from "../components/general/Loader";
import { Stack } from "react-bootstrap";
import SelectorDiscipline from "../components/common/selectors/selector-discipline/selectorDiscipline";
import TechnicalOfficialsTable from "../components/common/participants/TechnicalOfficialsTable";
import { useGetH1 } from 'helpers/commonCodes';
import { SELECTOR_DISPLAY_TYPE } from 'helpers/utils';
import { useLabels } from 'components/general/Label';


export default function TechnicalOfficials() {
    const [dataState, setDataState] = useState([]);
    const [nameFilter, setNameFilter] = useState('');
    const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters();
    const { h1s } = useGetH1({ mirs_competition });
    const [disciplinesArray, setDisciplinesArray] = useState();
    const fLabel = useLabels()
    const placeholder = fLabel({ data: 'LabelSearch' });
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['athletes', mirs_competition, mirs_language, 'J'],
            queryFn: getAthletes,
            refetchInterval: 0
            //staleTime: 5000,
            //refetchIntervalInBackground: true
        });

    useEffect(() => {
        const h1DiscArray = h1s.filter(h => h.orisNo === 'N23' && h.disciplineCode !== "EQU").map(h => h.disciplineCode) || [];
        const discArray = new Set();
        const filterdData = [];
        data?.persons?.forEach(tech => {
            let tempTech = tech;
            // empty tempTech if doesn't meet filter
            tech.disciplines = tech?.disciplines?.filter(techDisc => h1DiscArray?.includes(techDisc?.code));
            if (!tech?.disciplines?.some(itemDiscipline => h1DiscArray.includes(itemDiscipline?.code))) {
                tempTech = '';
            };

            // get discarray from available tech officials after filteration by h1s
            tech?.disciplines?.forEach(d => {
                discArray.add(d?.code);
            });
            if (mirs_discipline && mirs_discipline !== "all-disc") {
                if (!tech?.disciplines?.some(itemDiscipline => itemDiscipline?.code === mirs_discipline)) {
                    tempTech = '';
                }
            }

            if (nameFilter) {
                if (!tech?.name?.toLowerCase().includes(nameFilter?.toLowerCase())) {
                    tempTech = '';
                }
            }
            if (tempTech) filterdData.push(tempTech);
        });

        setDataState(filterdData);
        setDisciplinesArray([...discArray]);
    }, [data, mirs_discipline, h1s, nameFilter]);

    if (isError) {
        return <NotAvailable label="LabelNoDataAvailable" />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.persons) {
        return <NotAvailable label="LabelNoDataAvailable" />
    }


    const handleOnChange = event => {
        const { name, value } = event.target;
        let val = value;
        val = val.trimEnd();
        setNameFilter(val);
    };

    return (
        <>
            <PageHeader title='Technical Officials' />
            <div className='mirs-page-container'>
                <Stack direction="horizontal" className='selectors-container'>
                    <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="technicalofficials" disciplinesList={disciplinesArray} useDisciplinesList={true} />
                    <div className="d-flex competitor-search">
                        {/*<label htmlFor="city"><Label data={"HeaderNOC"} /></label>*/}
                        <input type="text" className="form-control" name="Search" id="Search"
                            placeholder={placeholder}
                            onChange={handleOnChange} />
                    </div>
                </Stack>
                <div>
                    {dataState && <TechnicalOfficialsTable data={dataState} key={`technicalofficials`} />}
                </div>
            </div>
        </>
    )
};